import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

const errorState = '&[data-error]'
const disabledState = '&:not([data-error])[disabled]'
const activeState = '&:not([disabled]):not([data-error])[data-active], &:not([disabled]):not([data-error]):focus'
const hoverState = '&:not([disabled]):not([data-error]):not([data-active]):not(:focus):hover, &:not([disabled]):not([data-error]):not(:focus)[data-hover]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.inputGroup', {
      length: {
        color: 'ash',
        userSelect: 'none',
        fontFamily: 'pfRegular',
        fontSize: '14px',
        '[data-error] &': {
          color: 'danger',
        },
      },
      affix: {
        px: 10,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      },
      addonBefore: {
        'cmp.inputGroup': 'affix',
        bg: '#fafafa',
        borderRight: '1px solid #d9d9d9',
      },
      addonAfter: {
        'cmp.inputGroup': 'affix',
        bg: '#fafafa',
        borderLeft: '1px solid #d9d9d9',
      },
      wrapper: {
        position: 'relative',
        display: 'inline-block',
        width: composeStyle.switch('size')
          .case('s', '240px')
          .case('m', '240px')
          .case('l', '400px'),
        '.slot-left': {
          position: 'absolute',
          left: 1,
          top: 1,
          bottom: 1,
          overflow: 'hidden',
          borderTopLeftRadius: '3px',
          borderBottomLeftRadius: '3px',
          display: 'flex',
          alignItems: 'center',
        },
        '.slot-right': {
          position: 'absolute',
          right: 1,
          top: 1,
          bottom: 1,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          borderTopRightRadius: '3px',
          borderBottomRightRadius: '3px',
        },
      },
      inputSize: composeStyle.switch('size')
        .case('s', {
          minHeight: 22,
          height: 22,
          fontSize: '14px',
          lineHeight: '14px',
        })
        .case('m', {
          height: 32,
          fontSize: '14px',
          lineHeight: '14px',
        })
        .case('l', {
          height: 40,
          lineHeight: '16px',
          fontSize: '16px',
        }),
      inputWrapper: {
        textRendering: 'unset',
        fontFamily: 'default',
        py: 0,
        boxSizing: 'border-box',
        border: composeStyle.when('bordered')
          .truthy('outlineoutline')
          .falsy('none'),
        borderRadius: 'control',
        width: '100%',
        display: 'inline-flex',
        flexWrap: 'wrap',
        minHeight: 32,
      },
      rangeInput: {
        [disabledState]: {
          cursor: 'not-allowed',
          pointerEvents: 'none',
          bg: '#fbfbfb',
          color: 'mute',
          fill: 'mute',
        },
        [errorState]: {
          caretColor: 'danger',
          borderColor: 'danger',
        },
        [hoverState]: {
          borderColor: 'palette.outline.hover',
        },
        [activeState]: {
          borderColor: 'brand',
        },
      },
      rangeInputItem: {
        'cmp.inputGroup': 'input',
        lineHeight: 32,
        borderRadius: 'control',
        px: 12,
        py: 0,
        flex: 1,
        border: 0,
        textAlign: 'center',
        width: 0, // override default input width..
      },
      baseInput: {
        appearance: 'none',
        outline: 'none',

        verticalAlign: 'middle',
        color: 'body',
        caretColor: 'brand',
        bg: 'white',
        fontSize: '14px',
        '&::placeholder': {
          color: 'ash',
        },
        '&[type=number]': {
          '&::-webkit-outer-spin-button': {
            appearance: 'none',
            m: 0,
          },
          '&::-webkit-inner-spin-button': {
            appearance: 'none',
            m: 0,
          },
        },
      },
      flexInput: {
        'cmp.inputGroup': 'baseInput',
        'cmp.inputGroup.inputWrapper': true,
        border: 'none',
        flex: '1',
        minWidth: 12,
      },
      input: {
        'cmp.inputGroup': 'baseInput',
        [errorState]: {
          caretColor: 'danger',
          borderColor: 'danger',
        },
        [hoverState]: {
          borderColor: 'palette.outline.hover',
        },
        [activeState]: {
          borderColor: 'brand',
        },
        [disabledState]: {
          cursor: 'not-allowed',
          bg: '#fbfbfb',
          color: 'mute',
          fill: 'mute',
          pointerEvents: 'none',
        },
      },
    }),
  ]
}
